import React from 'react';
import { SvgIcon } from '../../components';

export const TicketIcon = ({
    color = 'currentColor',
    className,
}: {
    color?: string;
    className?: string;
}) => {
    return (
        <SvgIcon
            width="24"
            height="24"
            viewBox="0 0 24 24"
            strokeWidth="2"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <path d="M15 5l0 2"></path>
            <path d="M15 11l0 2"></path>
            <path d="M15 17l0 2"></path>
            <path d="M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2"></path>
        </SvgIcon>
    );
};
